module.exports = __webpack_public_path__ + "static/media/git--gud-E-red.69bc71d4.svg";